// Fallback na window.location.hostname - appka se musí dát otestovat i z
// telefonu/jiného zařízení na LAN přes IP adresu dev počítače, ne jen z
// localhost. VUE_APP_API_URL (pokud je v .env nastavené, typicky produkce)
// má vždy přednost.
export const API_ENTRYPOINT = process.env.VUE_APP_API_URL || `https://${window.location.hostname}:444`;
